export default {
  data() {
    return {
      studyTypes: {
        anticoagulation: { label: 'Anticoagulación', selected: false },
        anemia: { label: 'Estudio de Anemia', selected: false },
        compatibility: { label: 'Compatibilidad Matrimonial', selected: false },
        hemostasis: { label: 'Hemostasia', selected: false },
        myelogram: { label: 'Mielograma Descriptivo', selected: false },
        thrombophilia: { label: 'Estudio de Trombofilia', selected: false },
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/study-types.js